// extracted by mini-css-extract-plugin
export default {"display":"TextField_display__rpeZH","value":"TextField_value__9CnC+","placeholder":"TextField_placeholder__MxOxO","editMode":"TextField_editMode__6XbLR"};